import { useEffect, useState } from "react";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import SearchBar from "../../../../Components/Utils/SearchBar";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import DataTable from "../../../../Components/Others/DataTable";
import { Link, useLocation } from "react-router-dom";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import MoreOptions from "../../../../Components/Utils/MoreOptions";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import ShipmentTrackingTable from "./ShipmentTrackingTable";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import { NuDate } from "../../../../Components/Utils/Input";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import Importdoc from "./Importdoc";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiEditST from "./MultiEditST";
import { GetAccess } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import ViewToggle from "../../../../Components/Utils/ViewToggle";

function ShipmentTrackingIndex() {
  const location = useLocation();
  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20,
  );
  const state = location.state;
  const [filter, setFilter] = useState(state?.shipmentStatus ? true : false);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("shipmentTrackingViewMode") || "table"
  );
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const effectiveViewMode = isMobile ? "card" : (viewMode === "list" ? "table" : viewMode);
  const { value: PortOfDischarge } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "PortOfDischarge",
    showFilterDialog,
  );
  const { value: PortOfLoading } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "PortOfLoading",
    showFilterDialog,
  );
  const { value: ShippingMethod } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "ShippingMethod",
    showFilterDialog,
  );
  const { value: ShippingStatus, getData: refShippingStatus } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "ShippingStatus",
    showFilterDialog,
  );
  const { value: IdentityType } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "ShipIdentityType",
    showFilterDialog,
  );

  const [filterProps, setFilterProps] = useState({
    shippedOnFrom: "",
    shippedOnTo: "",
    ETAFrom: "",
    ETATo: "",
    shipmentStatus: "",
    ETDFrom: "",
    ETDTo: "",
    identityType: "",
    modeOfShipment: "",
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    shippedOnFrom: "",
    shippedOnTo: "",
    ETAFrom: "",
    ETATo: "",
    shipmentStatus: state?.shipmentStatus ? state.shipmentStatus : "",
    ETDFrom: "",
    ETDTo: "",
    identityType: "",
    modeOfShipment: "",
  });

  const clearFilter = () => {
    setParams({
      ...params,
      shippedOnFrom: "",
      shippedOnTo: "",
      ETAFrom: "",
      ETATo: "",
      shipmentStatus: "",
      ETDFrom: "",
      ETDTo: "",
      identityType: "",
      modeOfShipment: "",
    });
    setFilter(false);
    formik.values.shippedOnFrom = "";
    formik.values.shippedOnTo = "";
    formik.values.ETAFrom = "";
    formik.values.ETATo = "";
    formik.values.shipmentStatus = "";
    formik.values.ETDFrom = "";
    formik.values.ETDTo = "";
    formik.values.identityType = "";
    formik.values.modeOfShipment = "";
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({
        ...params,
        shippedOnFrom: value.shippedOnFrom,
        shippedOnTo: value.shippedOnTo,
        ETAFrom: value.ETAFrom,
        ETATo: value.ETATo,
        shipmentStatus: value.shipmentStatus,
        ETDFrom: value.ETDFrom,
        ETDTo: value.ETDTo,
        identityType: value.identityType,
        modeOfShipment: value.modeOfShipment,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        shippedOnFrom: "",
        shippedOnTo: "",
        ETAFrom: "",
        ETATo: "",
        shipmentStatus: "",
        ETDFrom: "",
        ETDTo: "",
        identityType: "",
        modeOfShipment: "",
      });
    },
  });

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/shipping/",
    params,
  );
  console.log(data);

  const defaultHeader = [
    {
      title: "YPR",
      width: "9%",
      isLink: true,
      id: "shippingId",
      link: "/shipping/shipment-tracking/view/",
      field: "prRef",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "PO No.",
      width: "9%",
      field: "poRef",
      isLink: true,
      id: "shippingId",
      link: "/shipping/shipment-tracking/view/",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Shipping Agent",
      width: "9%",
      field: "agentName",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Shipping Method",
      width: "9%",
      field: "modeOfShipment",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "ETD",
      width: "9%",
      field: "ETD",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "ETA",
      width: "9%",
      field: "ETA",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Shipment Cost",
      width: "9%",
      fieldOne: "ASC",
      fieldTwo: "ESC",
      textAlign: "left",
      rowAlign: "left",
      hasTwo: true,
    },
    {
      title: "Status",
      width: "9%",
      field: "shipmentStatus",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "left",
      rowAlign: "left",
      contents: {
        // fetcher: getData,
        id: "shippingId",
        removeValue: "Shipment Tracking",
        url: "/shipping/",
        moduleName: "Shipment Tracking",
        from: "/shipping/shipment-tracking",
        editLink: "/shipping/shipment-tracking/edit/",
        viewLink: "/shipping/shipment-tracking/view/",
      },
    },
  ];

  let availableHeaders = [
    {
      title: "YPR",
      width: "9%",
      isLink: true,
      id: "shippingId",
      link: "/shipping/shipment-tracking/view/",
      field: "prRef",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "PO No.",
      width: "9%",
      field: "poRef",
      isLink: true,
      id: "shippingId",
      link: "/shipping/shipment-tracking/view/",

      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Shipping Agent",
      width: "9%",
      field: "agentName",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Shipping Method",
      width: "9%",
      field: "modeOfShipment",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Booking Date",
      width: "9%",
      field: "bookingDate",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Delivery Date By PO",
      width: "9%",
      field: "deliveryDatebyPO",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Delivery Date",
      width: "9%",
      field: "deliveryDate",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Bill Number",
      width: "9%",
      field: "shipmentBill",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "ETD",
      width: "9%",
      field: "ETD",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "ETA",
      width: "9%",
      field: "ETA",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Shipment Cost",
      width: "9%",
      fieldOne: "ASC",
      fieldTwo: "ESC",
      textAlign: "left",
      rowAlign: "left",
      hasTwo: true,
    },

    {
      title: "Status",
      width: "9%",
      field: "shipmentStatus",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Actual Arrival Date",
      width: "9%",
      field: "actualArrivalDate",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Shipping On",
      width: "9%",
      field: "shippedOn",
      type: "date",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Delivery Person ",
      width: "9%",
      field: "deliveryPersonName",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Identity Type",
      width: "9%",
      field: "identityType",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Identity Number",
      width: "9%",
      field: "identityNumber",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Vehicle Type",
      width: "9%",
      field: "vehicleType",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Vehicle Number",
      width: "9%",
      field: "vehicleNumber",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Permit Requitred",
      width: "9%",
      field: "permitReq",
      isCondition: true,
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "left",
      rowAlign: "left",
      contents: {
        // fetcher: getData,
        id: "shippingId",
        removeValue: "Shipment Tracking",
        url: "/shipping/",
        moduleName: "Shipment Tracking",
        from: "/shipping/shipment-tracking",
        editLink: "/shipping/shipment-tracking/edit/",
        viewLink: "/shipping/shipment-tracking/view/",
      },
    },
  ];

  useEffect(() => {
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showImportModal, setShowImportModal] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    console.log(e.target.checked);
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        console.log("I", i?.shippingId);
        tempArr.push(i?.shippingId);
      });
    setFullList(tempArr);
  }, [data]);

  return (
    <div className="w-full h-full p-2 sm:px-4">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[
              {
                name: "Shipping",
              },
              {
                name: "Shipment Tracking",
              },
            ]}
          />
          <div className="flex md:hidden items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("shipment_tracking_create") && (
              <Link to="/shipping/shipment-tracking/create">
                <CreateButton label="Shipment Tracking" />
              </Link>
            )}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center gap-2">
          <div className="w-full md:w-fit">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1);
              }}
              value={params.search}
            />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
          </div>

          {/* Table / Card View Toggle */}
          <ViewToggle
            viewMode={effectiveViewMode}
            onViewChange={(mode) => setViewMode(mode)}
            storageKey="shipmentTrackingViewMode"
          />

          <div className="hidden md:flex items-center gap-2">
            {GetAccess("shipment_tracking_create") && (
              <Link to="/shipping/shipment-tracking/create">
                <CreateButton label="Shipment Tracking" />
              </Link>
            )}
          </div>
        </div>
      </div>

      <ShipmentTrackingTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        searchQuery={params?.search != "" ? params?.search : ""}
        listofNumbers={listofNumbers}
        selectOneFunction={selectOneFunction}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        fetcher={getData}
        dataLoading={dataLoading}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        viewMode={effectiveViewMode}
      />
      {/* <CustomDataTable
        fetcher={getData}
    data={data}
     availableHeaders={availableHeaders}
        defaultHeader={defaultHeader}
        bodyHeight="max-h-[calc(100vh-260px)]"
        height="h-[calc(100vh-145px)]"
   total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
   title="Shipment Tracking List"
        storageName="ShipmentTrackingTable"
selectOneFunction={selectOneFunction}
        setShowDelete={setShowDelete}
        showDelete={showDelete}
  setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        hasMultiEdit={true}
     
        getById="shippingId"
        editAccess="shipment_tracking_edit"
        deteleAccess="shipment_tracking_delete"
        dataLoading={dataLoading}
        searchQuery={params?.search != "" ? params?.search : ""}
        orderflow="Shipment" /> */}
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-3 sm:p-4">
          <div className="animate-scale-in w-full sm:w-[520px] max-w-[95vw] max-h-[90vh] bg-white py-4 px-4 sm:px-6 rounded-xl shadow-lg overflow-y-auto">
            <h2 className="text-lg font-bold text-gray-800 mb-4">Filter Shipment Tracking</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col gap-3 mb-4">
                <div>
                  <p className="py-1 text-xs font-semibold text-gray-700">Shipped On</p>
                  <div className="flex flex-col sm:flex-row gap-2 w-full">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="shippedOnFrom"
                      width="w-full"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="shippedOnTo"
                      width="w-full"
                    />
                  </div>
                </div>
                <div>
                  <p className="py-1 text-xs font-semibold text-gray-700">ETA</p>
                  <div className="flex flex-col sm:flex-row gap-2 w-full">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="ETAFrom"
                      width="w-full"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="ETATo"
                      width="w-full"
                    />
                  </div>
                </div>
                <div>
                  <p className="py-1 text-xs font-semibold text-gray-700">ETD</p>
                  <div className="flex flex-col sm:flex-row gap-2 w-full">
                    <NuDate
                      label="From"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="ETDFrom"
                      width="w-full"
                    />
                    <NuDate
                      label="To"
                      placeholder="dd/mm/yyyy"
                      formik={formik}
                      name="ETDTo"
                      width="w-full"
                    />
                  </div>
                </div>

                <FormikSelectTwo
                  label="Identity Type"
                  placeholder="Choose"
                  Options={IdentityType}
                  formik={formik}
                  name="identityType"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="Mode Of Shipment"
                  placeholder="Choose"
                  Options={ShippingMethod}
                  formik={formik}
                  name="modeOfShipment"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Shipping Status"
                  placeholder="Shipping Status"
                  Options={ShippingStatus}
                  formik={formik}
                  name="shipmentStatus"
                  width="w-full"
                />
              </div>
              <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showImportModal && (
        <Importdoc
          show={showImportModal}
          onClose={closeModal}
          getData={getData}
        />
      )}
      {showEdit && (
        <MultiEditST
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  );
}

export default ShipmentTrackingIndex;
